export default __webpack_public_path__ + "static/media/Eritrea.e3ba8474.png";